import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    filter: [],
    search: ""
};

const filterSlice = createSlice({
    name: "filter",
    initialState,
    reducers: {
        addManyFilter: (state, action)=>{
            state.filter = action.payload
        },
        toggleFilter: (state, action)=>{
            const exist = state.filter.find(item=>item.id === action.payload.id)
            if(exist){
                state.filter = state.filter.filter(item=>item.id !== exist.id)
            }else{
                state.filter.push(action.payload)
            }
        },
        setSearch: (state, action)=>{
            state.search = action.payload
        }
    },
});

export const {addManyFilter, toggleFilter, setSearch} = filterSlice.actions;
export default filterSlice.reducer;